import http, { API_CORE } from '../../http';

export default function AddressServiceV2() {
  const getAddresses = async (params) => {
    const response = await http(API_CORE).get('/v2/addresses', { params });
    return response.data;
  };

  const getAddressById = async (id) => {
    const response = await http(API_CORE).get(`/v2/addresses/${id}`);
    return response.data;
  };

  const createAddress = async (data) => {
    const response = await http(API_CORE).post('/v2/addresses', data);
    return response.data.address;
  };

  const updateAddress = async ({ id, ...data }) => {
    const response = await http(API_CORE).patch(`/v2/addresses/${id}`, data);
    return response.data.address;
  };

  const deleteAddress = async ({ id }) => {
    const response = await http(API_CORE).delete(`/v2/addresses/${id}`);
    return response.data;
  };

  return {
    getAddresses,
    getAddressById,
    createAddress,
    updateAddress,
    deleteAddress,
  };
}
